import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const LANG_LABELS = { pt: 'PT-BR', en: 'EN-US', es: 'ES-419' };

const StyledChip = styled.span`
  display: inline-block;
  margin-left: 4px;
  height: 16px;
  font-size: 10px;
  border-radius: 4px;
  vertical-align: middle;
  padding: 0 6px;
  line-height: 14px;
  border: 1px solid var(--vo-cloud);
  color: var(--vo-slate);
  background: white;
`

export const LanguageIndicatorChip = ({ language }) => {
  const { t } = useTranslation('audit');
  if (!language || !LANG_LABELS[language]) return null;
  const langName = t(`_meta.languages.${language}`);
  return (
    <span title={t('_meta.languageIndicator', { lang: langName })}>
      <StyledChip>{LANG_LABELS[language]}</StyledChip>
    </span>
  );
};
